module.exports = __webpack_public_path__ + "img/compromiso.9669f18d.png";